import { render, staticRenderFns } from "./staffList.vue?vue&type=template&id=bc2f056e&scoped=true"
import script from "./staffList.vue?vue&type=script&lang=js"
export * from "./staffList.vue?vue&type=script&lang=js"
import style0 from "./staffList.vue?vue&type=style&index=0&id=bc2f056e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2f056e",
  null
  
)

export default component.exports